export interface StatamicNavItem {
    page: {
        id: string
        url: string
        title: string
    }
    depth: number
    children: StatamicNavItem[]
}

export interface StatamicNavTreeRequest {
    handle: string
}

export const useStatamicNavs = () => {
    const statamic = useStatamic()

    const getNavTree = <T extends StatamicNavItem>(
        data: StatamicNavTreeRequest,
    ) => statamic<T[]>(`/navs/${data.handle}/tree`)

    return {
        getNavTree,
    }
}
